import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Button, Card, CardBody } from 'reactstrap';
import {useNavigate, useLocation } from 'react-router-dom'

import { getClientById } from '../../../../redux/actions/client';
import Loading from '../../../../components/Loading/Loading';
import styles from './styles.module.scss';
import PersonalDataTable from './subcomponents/PersonalData';
import LeadData from './subcomponents/LeadData';
import OfferData from './subcomponents/OfferData';
import QuotationData from './subcomponents/QuotationData';

function ClientDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const detailState = useSelector((state) => state.client.getById);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [activeSection, setActiveSection] = useState('personal');

  useEffect(() => {
    document.title = 'BGL - Detalle del cliente';
    const clientId = location.pathname.split('/').pop();
    dispatch(getClientById(clientId));
  }, []);

  useEffect(() => {
    if (detailState) {
      if (detailState.status === 'danger') {
        setAlertMessage(detailState.message);
        setLoading(false);
      } else {
        setData(detailState.data);
        setLoading(false);
      }
    }
  }, [detailState]);

  const isSectionActive = (section) => activeSection === section;

  const toggleSection = (section) => {
    if (activeSection === section) {
      setActiveSection(null);
    } else {
      setActiveSection(section);
    }
  };

  const goToClientList = () => {
    navigate('/client-list');
  };

  const goToEditClient = (clientId) => {
    navigate(`/client-form/${clientId}`);
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      {detailState.status === 'danger' && (
        <Container className="container-border p-3">
          <Button className="float-right mb-2" onClick={() => goToClientList()}>
            <i className="fa fa-arrow-left mr-3"></i>
            <span>Volver</span>
          </Button>
          <h2>{alertMessage}</h2>
          <p>
            No hemos podido encontrar la información del cliente. Si el problema
            persiste, por favor contacte al administrador del sistema.
          </p>
        </Container>
      )}

      {detailState.status !== 'danger' && (
        <Container className="container-border p-3">
          <Button
            className="float-right mb-2"
            onClick={() => goToEditClient(detailState.data.id)}
          >
            <i className="fa fa-edit mr-3"></i>
            <span>Editar</span>
          </Button>
          <Button className="float-right mb-2" onClick={() => navigate(-1)}>
            <i className="fa fa-arrow-left mr-3"></i>
            <span>Volver</span>
          </Button>
          <h2>Detalle del cliente</h2>
          <article className={styles.sectionButtons}>
            <Button
              color={isSectionActive('personal') ? 'primary' : 'secondary'}
              onClick={() => toggleSection('personal')}
              className={styles.sectionButton}
            >
              Datos Personales
            </Button>
            <Button
              color={isSectionActive('leads') ? 'primary' : 'secondary'}
              onClick={() => toggleSection('leads')}
              className={styles.sectionButton}
            >
              Leads
            </Button>
            <Button
              color={isSectionActive('offers') ? 'primary' : 'secondary'}
              onClick={() => toggleSection('offers')}
              className={styles.sectionButton}
            >
              Ofertas
            </Button>
            <Button
              color={isSectionActive('budgets') ? 'primary' : 'secondary'}
              onClick={() => toggleSection('budgets')}
              className={styles.sectionButton}
            >
              Cotizaciones
            </Button>
            <Button
              color={isSectionActive('assets') ? 'primary' : 'secondary'}
              onClick={() => toggleSection('assets')}
              className={styles.sectionButton}
            >
              Bienes
            </Button>
          </article>

          {isSectionActive('personal') && (
            <Card>
              <CardBody>
                <PersonalDataTable data={data} />
              </CardBody>
            </Card>
          )}

          {isSectionActive('leads') && (
            <Card>
              <CardBody>
                <LeadData clientId={detailState.data.id} />
              </CardBody>
            </Card>
          )}

          {isSectionActive('offers') && (
            <Card>
              <CardBody>
                <OfferData clientId={detailState.data.id} />
              </CardBody>
            </Card>
          )}

          {isSectionActive('budgets') && (
            <Card>
              <CardBody>
                <QuotationData clientId={detailState.data.id} />
              </CardBody>
            </Card>
          )}

          {isSectionActive('assets') && (
            <Card>
              <CardBody>
                <h4 className="mt-0">Bienes</h4>
                <p>No hay bienes para este cliente</p>
              </CardBody>
            </Card>
          )}
        </Container>
      )}
    </>
  );
}

export default ClientDetail;
